export const PASSWORD_RESET_TECHNICIANS =  `
    mutation ($id_technician: ID!, $new_password: String!) {
            resetPasswordTechnician(id_technician: $id_technician, new_password: $new_password) {
                message
                result
            }
    }
`;